const colorMap = {
  'text-pw-primary': { bg: 'bg-pw-accent-light', text: 'text-pw-primary' },
  'text-pw-success': { bg: 'bg-pw-on-success', text: 'text-pw-success' },
  'text-pw-warning': { bg: 'bg-pw-on-warning', text: 'text-pw-warning' },
  'text-pw-error': { bg: 'bg-pw-on-error', text: 'text-pw-error' },
  'text-pw-info': { bg: 'bg-blue-50', text: 'text-pw-info' },
  'text-pw-secondary-alt': { bg: 'bg-purple-50', text: 'text-pw-secondary-alt' },
};

const StatCard = ({ icon: Icon, label, value, color = 'text-pw-primary', subtext }) => {
  const c = colorMap[color] || { bg: 'bg-pw-accent-light', text: 'text-pw-primary' };
  return (
    <div className="card p-4 lg:p-5">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${c.bg}`}>
          <Icon className={`w-5 h-5 ${c.text}`} />
        </div>
        <div>
          <p className="text-sm text-pw-text-variant">{label}</p>
          <p className={`text-2xl font-bold mt-0.5 ${c.text}`}>{value}</p>
          {subtext && <p className="text-xs text-pw-hint mt-1">{subtext}</p>}
        </div>
      </div>
    </div>
  );
};
export default StatCard;
